import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/clients/:clientId/surveys/:surveyId',
    name: 'Flow',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "question-flow" */ '../views/QuestionFlowPlot.vue'),
  },
  {
    path: '/survey',
    name: 'Survey',
    component: () => import(/* webpackChunkName: "survey" */ '../views/Survey.vue'),
  },
  {
    path: '/clients',
    name: 'Clients',
    component: () => import(/* webpackChunkName: "clients" */ '../views/Client')
  },
  {
    path: '/clients/:id',
    name: "Client detail",
    component: () => import(/* webpackChunkName: "clients" */ '../views/ClientDetails')
  }
];

const router = new VueRouter({
  routes,
});

export default router;
